import React, { useState, useEffect } from 'react'
import SeminarCard from 'components/seminar/SeminarCard'

const pickApplying = (data, now) => {
  if (!data || !Array.isArray(data)) return []
  return data
    .filter((edge) => {
      if (!edge?.node?.seminarStart) return false
      const startDate = new Date(edge.node.seminarStart)
      return !isNaN(startDate.getTime()) && now < startDate
    })
    .sort((a, b) => {
      const dateA = new Date(a.node?.seminarStart)
      const dateB = new Date(b.node?.seminarStart)
      if (isNaN(dateA.getTime()) || isNaN(dateB.getTime())) return 0
      return dateA.getTime() - dateB.getTime()
    })
}

/** @param {{ data?: any[], buildTime?: string }} props */
const SeminarApplyingList = ({ data, buildTime }) => {
  const [filteredSeminars, setFilteredSeminars] = useState(/** @type {any[]} */ ([]))
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    /* oxlint-disable-next-line react/set-state-in-effect -- ビルド時ではなくブラウザで開いた時点の時刻で受付中を絞るため */
    setIsClient(true)
    setFilteredSeminars(pickApplying(data, new Date()))
  }, [data])

  /* JS が動くまでは、ビルドの時点で受付中だったカードを見えない状態で HTML に出しておく。
     画像を先に読み込ませ、JS で描くと要る gatsby-plugin-image の追加の JS も待たずに済む。
     見せるのは閲覧した時刻で絞ってから（ビルドの後に始まったセミナーを一瞬でも出さないため。#827） */
  const seminars = isClient ? filteredSeminars : buildTime ? pickApplying(data, new Date(buildTime)) : []

  return (
    <div className="seminarApplyingList">
      {isClient && seminars.length === 0 ? (
        <p className="seminarApplyingList__text">現在申込受付中のセミナーはありません。</p>
      ) : seminars.length === 0 ? (
        ''
      ) : (
        <ul className="seminarApplyingList__list" aria-busy={isClient ? undefined : true}>
          {seminars.map((edge) => {
            return (
              <li className="seminarApplyingList__item" key={edge?.node?.id}>
                <SeminarCard data={edge?.node} loading="eager" />
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}

export default SeminarApplyingList
